/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 846:
/***/ ((module, exports, __webpack_require__) => {

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  ModuleContextHandler
} = __webpack_require__(495);
let appContextValue = {};
const updateAppContextByModule = (moduleName, moduleContext) => {
  appContextValue[moduleName] = moduleContext;
};
const getModuleState = moduleName => ModuleContextHandler.getState(appContextValue, moduleName);
const setModuleState = (moduleName, state) => {
  const currentModuleContext = ModuleContextHandler.setState(appContextValue, moduleName, state);
  updateAppContextByModule(moduleName, currentModuleContext);
};
const getModuleInstances = moduleName => ModuleContextHandler.getInstances(appContextValue, moduleName);
const addModuleInstance = (moduleName, instance) => {
  const currentModuleContext = ModuleContextHandler.addInstance(appContextValue, moduleName, instance);
  updateAppContextByModule(moduleName, currentModuleContext);
};
const removeModuleInstance = (moduleName, instance) => {
  const currentModuleContext = ModuleContextHandler.removeInstance(appContextValue, moduleName, instance);
  updateAppContextByModule(moduleName, currentModuleContext);
};
const mapInstancesToState = moduleName => {
  const instances = getModuleInstances(moduleName);
  const state = instances.map(instance => {
    const instanceProps = _objectSpread({}, instance.props);
    delete instanceProps.context;
    delete instanceProps.effectContext;
    return instanceProps;
  });
  return state;
};
const getAppContextValue = () => appContextValue;
const appContextFactory = function () {
  let contextValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : appContextValue;
  appContextValue = contextValue;
  return {
    getModuleState,
    setModuleState,
    getModuleInstances,
    addModuleInstance,
    removeModuleInstance,
    mapInstancesToState
  };
};
module.exports = appContextFactory;
exports = module.exports;
exports.appContextFactory = appContextFactory;
if (false) {}

/***/ }),

/***/ 495:
/***/ ((module, exports) => {

const initializeModuleContextIfApplies = moduleContext => {
  if (!moduleContext) {
    const currentModuleContext = {
      state: null,
      instances: new Set()
    };
    return currentModuleContext;
  }
  return moduleContext;
};
const getState = (appContext, moduleName) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  if (moduleContext === null || !moduleContext.state) {
    return null;
  }
  if (Array.isArray(moduleContext.state) || moduleContext.state instanceof Set || typeof moduleContext.state === 'object') {
    return JSON.parse(JSON.stringify(moduleContext.state));
  }
  return moduleContext.state;
};
const setState = (appContext, moduleName, state) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  const currentModuleContext = initializeModuleContextIfApplies(moduleContext);
  currentModuleContext.state = state;
  return currentModuleContext;
};
const getInstances = (appContext, moduleName) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  return moduleContext !== null && moduleContext.instances ? [...moduleContext.instances] : null;
};
const addInstance = (appContext, moduleName, instance) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  const currentModuleContext = initializeModuleContextIfApplies(moduleContext);
  currentModuleContext.instances.add(instance);
  return currentModuleContext;
};
const removeInstance = (appContext, moduleName, instance) => {
  const moduleContext = (appContext === null || appContext === void 0 ? void 0 : appContext[moduleName]) || null;
  if (moduleContext !== null && moduleContext !== void 0 && moduleContext.instances) {
    moduleContext.instances.delete(instance);
    return moduleContext;
  }
  return null;
};
const ModuleContextHandler = {
  setState,
  addInstance,
  getState,
  getInstances,
  removeInstance
};
module.exports = ModuleContextHandler;
exports = module.exports;
exports.ModuleContextHandler = ModuleContextHandler;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(846);
/******/ 	module.exports.appContextFactory = __webpack_exports__;
/******/ 	
/******/ })()
;